import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators, ReactiveFormsModule } from '@angular/forms';
import { activeMenuList, helpMenuWise } from 'src/app/utils/utils';
import { ToastrService } from 'ngx-toastr';
import { environment } from 'src/environments/environment';
import { CommonModule } from '@angular/common';
import { Labels } from 'src/app/constants/labels';
import { CommonService } from 'src/app/services/common-service/common.service';

@Component({
  selector: 'app-oghelp',
  templateUrl: './oghelp.component.html',
  styleUrls: ['./oghelp.component.scss'],
  imports:[ReactiveFormsModule,CommonModule]
})
export class OghelpComponent implements OnInit {

  helpForm: FormGroup | any;
  allMenu = helpMenuWise;
  mainMenus: any = [];
  contentTitle = '';
  selectedMenuId = 0;
  helpContents: any;
  displaySearchTxt = '';
  activeMenu = [];
  menuUrlwise = activeMenuList;
  messageLabel = Labels.messages;

  constructor(private formBuilder: FormBuilder,private commonService: CommonService, private toastr: ToastrService) { }

  ngOnInit(): void {
    const root = environment.appUrl;
    this.helpForm = this.formBuilder.group({
      searchOn: false,
      searchText: [],
      searchData: []
    });
    // console.log('root:', root);
    let activeMenuData = this.menuUrlwise.filter(item => item.url == root);
    let urlMenuData = activeMenuData[0]['activeMenu'];
    // console.log('activeMenus:', activeMenuData);
    this.loadMainMenu(urlMenuData);
  }

  loadMainMenu(urlMenuData: any) {
    // console.log('urlMenuData:', urlMenuData);
    let menuIndex = 0;
    urlMenuData.forEach((element: any) => {
      this.allMenu.forEach(menuItem => {
        if (menuItem.id == element) {
          menuItem.isActive = true;
          if (menuItem.parent_id == 0) {
            this.mainMenus.push({
              id: menuItem.id, parent_id: menuItem.parent_id, name: menuItem.name, isActive: true,
              content: ''
            })
          }
        }
      });

    })
    // console.log('this.allMenu:', this.allMenu)
    // this.mainMenus = this.allMenu.filter(item => item.parent_id == 0 && item.isActive == true);
    // console.log('this.mainMenus:', this.mainMenus)
  }

  loadSubMenu(id: any) {
    let subMenus = this.allMenu.filter(item => item.parent_id == id && item.isActive == true);
    // console.log('subMenus:', subMenus)
    return subMenus;
  }

  loadChildMenu(id: any) {
    let childMenus = this.allMenu.filter(item => item.parent_id == id);
    // console.log('childMenus:', childMenus)
    return childMenus;
  }

  loadSubContent(slMenu: any) {
    // console.log('slMenu:', slMenu);
    let parentMenu = this.allMenu.filter(item => item.id == slMenu.parent_id);
    // console.log('parentMenu:', parentMenu);
    this.contentTitle = ` | ${parentMenu[0]['name']} > ${slMenu.name}`;
    this.selectedMenuId = slMenu.id;
    this.helpContents = slMenu.content;
    this.helpForm.patchValue({
      searchOn: false
    });
    const divScroll = document.getElementById('divcontent');
    if (divScroll) {
      divScroll.scrollIntoView(true);
    }
  }

  searchContent() {
    let searchTxt = this.helpForm.value.searchText;
    // console.log('searchTxt:', this.searchTxt);
    if (searchTxt != null) {
      let strLen = searchTxt.length;
      if (strLen >= 3) {
        let filterContent = this.allMenu.filter(item => item.content.toLowerCase().includes(searchTxt.toLowerCase()) && item.isActive == true);
        // console.log('filterContent:', filterContent);
        this.helpForm.patchValue({
          searchOn: true,
          searchData: filterContent
        });
        this.displaySearchTxt = searchTxt;
      } else {
       // this.toastr.warning('Please enter atlease 3 text');
        this.commonService.showModalValidate('Please enter atlease 3 text.','',this.messageLabel.static_messages.warning,'Please enter atlease 3 text.');
        // console.log('Please add atlease 3 text');
      }
    } else {
     // this.toastr.warning('Please enter text');
      this.commonService.showModalValidate('Please enter text.','',this.messageLabel.static_messages.warning,'Please enter text.');
      this.helpForm.patchValue({
        searchOn: false,
        searchData: []
      });
    }
  }


}
